import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { brokerExample } from '../../data/loanCommission';
import { CommissionLine } from '../../types/commission';
import { formatPct, formatUsd } from '../../utils/format';
import { Card } from '../sf/Card';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { CommissionLinesTable } from './CommissionLinesTable';
interface ReferenceExamplesCardProps {
  lines: CommissionLine[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onRuleKeyClick: () => void;
}
export function ReferenceExamplesCard({
  lines,
  selectedId,
  onSelect,
  onRuleKeyClick
}: ReferenceExamplesCardProps) {
  const broker = brokerExample;
  return <Card title="Reference examples from other loans" icon={BookOpenIcon} iconBg="#706E6B" meta="A 60 / 40 split, a Miami Director row (5 bps from the employee record), a self-gen skipped Team Lead row, an adjustment from a locked period, and a Broker loan." bodyClassName="" actions={<ExampleDataBadge data-id="element-533" data-mp="xtz3hnmsm5wl" />} data-id="element-532" data-mp="2nuvri3bw9ucx">
      <CommissionLinesTable lines={lines} selectedId={selectedId} onSelect={onSelect} onRuleKeyClick={onRuleKeyClick} showLoanNumber data-id="element-534" data-mp="xv1vjyvuqee3" />
      <div className="border-t border-sf-border px-4 py-3" data-id="element-535" data-mp="p0doq4amoon6">
        <p className="text-[13px] font-semibold" data-id="element-536" data-mp="oyj5cuf094l7">Broker non-HELOC loan · Adjusted Loan Amount</p>
        <p className="mt-0.5 text-[13px] tabular-nums" data-id="element-537" data-mp="k3di9s9v9jvj">
          {formatUsd(broker.loanAmount)} × Total Comp Broker {formatPct(broker.compPct)} = {formatUsd(broker.revenue)} · no fee short ÷ {formatPct(broker.divisorPct)} (
          {broker.divisorRuleKey}) = <strong data-id="element-538" data-mp="17qbzis5t8vui">{formatUsd(broker.adjustedAmount)}</strong>
        </p>
        <p className="text-xs text-sf-weak" data-id="element-539" data-mp="12s0nqbvygb9n">Total Comp Broker % = Commissions ÷ Loan Amount × 100. Broker loans never have a fee short.</p>
      </div>
    </Card>;
}